import * as React from 'react';
import * as RX from 'reactxp';

import * as moment from 'moment';

import DatePicker from 'react-datepicker'
import MaskedTextInput from 'react-text-mask';

import { applyBreakpoints, md } from '../../utils/breakpoints';
import t from '../../utils/i18n';
import { colors } from '../../utils/styles';
import Check from '../svgs/check';
import ErrorX from '../svgs/error_x';

import 'react-datepicker/dist/react-datepicker.css';
import './DatepickerCustomStyle.css';

//tslint:disable
const styles = {
    mediumWidth: RX.Styles.createViewStyle({
        width: 400,
    }),
}
class DateSelector extends React.Component<{
    date: any, showError: boolean, onChange: (value: any, popup: boolean) => void, multiplier: number
}, { date: any, value: any, subText?: string, restartYear: boolean; selectionStart?: number, selectionEnd?: number,  /*isHtmlInputDateCompatible: boolean,*/ blur: boolean, clicking?: boolean }> {

    public static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (nextProps.date !== prevState.date) {
            return { date: nextProps.date, value: nextProps.date };
        } else {
            return null;
        }
    }

    constructor(props: { date: any, showError:boolean, onChange: (value: any) => void, multiplier: number }) {
        super(props);
        // const userAgent = window.navigator.userAgent;

        this.state = {
            blur: true,
            date: this.props.date,
            restartYear: true,
            selectionStart: -1,
            value: this.props.date ?
                (typeof this.props.date === 'string') ? moment(new Date(this.props.date), this.DateFormatForMoment) : this.props.date.format(this.DateFormatForMoment)
                : '',
        }

        this.handleChangeRaw = this.handleChangeRaw.bind(this);
        this.handleChangeMoment = this.handleChangeMoment.bind(this);
        this.handleEnter = this.handleEnter.bind(this);
        this.handleDateBlur = this.handleDateBlur.bind(this);
    }

    readonly DateFormatForMoment = 'MM/DD/YYYY'
    readonly DateFormatForInput = 'YYYY-MM-DD'

    public render() {
        const { multiplier, showError } = this.props;
        const { subText } = this.state;
        // const scroller = window.scroll;
        const width = window.innerWidth - (64 * multiplier);

        var maxMomentDate = moment();
        // var maxDateFormatted = maxMomentDate.format(this.DateFormatForInput);

        var minMomentDate = moment().add(-120, "years");
        // var minDateFormatted = minMomentDate.format(this.DateFormatForInput);
        
        const web = RX.Platform.getType() === 'web';

        return (
            <div>
                {
                    subText && <h4 style={{ maxWidth: width >= md ? 400 : width, marginBottom: 0, fontSize: 14 * multiplier, fontWeight: 400, marginTop: 0 * multiplier, color: colors.alert }}>{subText}</h4>
                }
                {
                    <div id='datepickerWrapper' className={'customDatePickerWidth'}>
                        <DatePicker
                            customInput={
                                <MaskedTextInput
                                    type='text'
                                    placeholder={this.DateFormatForMoment}
                                    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                                />
                            }
                             
                            className={'noRedBorder'}
                            showYearDropdown
                            showMonthDropdown
                            selected={this.state.value ? moment(this.state.value, this.DateFormatForMoment) : null}
                            dropdownMode={"select"}
                            placeholderText={this.DateFormatForMoment}
                            maxDate={maxMomentDate}
                            minDate={minMomentDate}
                            onChange={this.handleChangeMoment}
                            onChangeRaw={this.handleChangeRaw}
                            popperPlacement="bottom-start"
                            onBlur={this.handleDateBlur}
                            onFocus={(e: any) => {
                                // DatePickerLabel is located at the symptom_checker
                                const inputLabel = web && document.getElementById('DatePickerLabel');
                                const userAgent = web && window.navigator.userAgent;
                                const mobile = userAgent && (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('Android') > -1);
                                web && mobile && inputLabel && inputLabel.scrollIntoView();
                            }
                            }
                        />
                        {(this.state.value) && RX.createElement(Check, { style: { color: colors.green, height: 35 * multiplier, width: 35 * multiplier,minWidth: 20 * multiplier } })}
                        {( showError) && RX.createElement(ErrorX, { style: { color: colors.red, height: 35 * multiplier, width: 35 * multiplier, minWidth: 20 * multiplier } })}
                        
                    </div>
                }
            </div>
        );
    }

    private handleEnter() {

        const { value } = this.state

        const date = value ? new Date(value) : '';
        date && date.setDate(date && date.getUTCDate());

        if (!date || (date && (date.toString() === 'Invalid Date' || date.toString() === ''))) {
            this.props.onChange && this.props.onChange('', false); //tslint:disable-line
            this.setState({ date: '', value: '', subText: t('symptomChecker.datepicker.invalidDate') });
            return;
        }

        if (new Date() < date) {
            this.setState({ date: '', value: '', subText: t('symptomChecker.datepicker.invalidDate') });
            this.props.onChange && this.props.onChange('', false); //tslint:disable-line
            return;
        }

        const momentDate = date && moment(date, this.DateFormatForMoment);
        const today = new Date();
        const sameDate = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear() - 200;

        if (moment().diff(momentDate, 'years') >= 120 && !sameDate) {
            this.setState({ date: '', value: '', subText: t('symptomChecker.datepicker.invalidPastDate') });
            this.props.onChange && this.props.onChange('', false); //tslint:disable-line
            return;
        }

        date && momentDate && moment().diff(momentDate, 'days') >= 0 && this.props.onChange && this.props.onChange(momentDate, true);
        date && momentDate && this.setState({ date: momentDate, value: momentDate.format(this.DateFormatForMoment), subText: '' }); //tslint:disable-line

        date && momentDate && moment().diff(momentDate, 'years') <= 0 && this.setState({ subText: t('symptomChecker.callPhysician') }); //tslint:disable-line

        if (momentDate.isValid() === false) {
            this.props.onChange && this.props.onChange('', false);
            this.setState({ date: '', value: '', subText: t('symptomChecker.datepicker.invalidDateFormat') });
        }
    }

    private handleChangeRaw({ target: { value } }) {
        
        const momentDate = moment(new Date(value), this.DateFormatForMoment);
        if (momentDate.isValid()) {
            
            this.setState({ value: momentDate.format(this.DateFormatForMoment) }, () => this.handleEnter());
        }
    }

    private handleDateBlur(momentValue) {
        if (momentValue.type === 'blur') {
            var date = moment(momentValue.currentTarget.value, this.DateFormatForMoment);
            
            if (date.isValid() === false) {
                this.props.onChange && this.props.onChange('', false);
                this.setState({ date: '', value: '', subText: t('symptomChecker.datepicker.invalidDateFormat') });
            }
        }
    }
    private handleChangeMoment(momentValue) {
        const value = momentValue && momentValue.format(this.DateFormatForMoment);
        this.setState({ value }, () => this.handleEnter());
    }
}

export default DateSelector;



// WEBPACK FOOTER //
// ./src/modules/date_picker/index.web.tsx